import { or } from 'tio-ui/utilities';
import { t } from 'ember-intl';
import FileUploader from '../../../file-uploader.gts';
import type { TOC } from '@ember/component/template-only';
import { PhCloudArrowUp } from 'ember-phosphor-icons';

interface UploadAttachmentsUploaderSignature {
  Args: {
    didUploadFile: (content: unknown) => void;
    isProcessing: boolean;
    disabled?: boolean;
    useDropzone?: boolean;
    iconOnlyUpload?: boolean;
  };
}

const TuitionAssistanceFormsUploadAttachmentsUploaderComponent: TOC<UploadAttachmentsUploaderSignature> =
  <template>
    {{#if @useDropzone}}
      <FileUploader
        @didUploadFile={{@didUploadFile}}
        @disabled={{@disabled}}
        @useDropzone={{@useDropzone}}
      />
    {{else if @iconOnlyUpload}}
      <FileUploader @didUploadFile={{@didUploadFile}} as |uploader|>
        <input
          id={{uploader.uniqueId}}
          type="file"
          multiple="true"
          {{uploader.queue.selectFile}}
          class="hidden"
          disabled={{or @disabled uploader.queue.files.length @isProcessing}}
        />
        <label
          for={{uploader.uniqueId}}
          class="cursor-pointer text-center font-semibold uppercase flex items-start justify-center relative overflow-hidden px-3
            {{unless @iconOnlyUpload 'border max-w-48 pb-6 bg-white'}}
            {{if
              @disabled
              'border-neutral-300 text-neutral-300'
              'border-ocean-600 hover:border-ocean-800 text-ocean-600 hover:text-ocean-800'
            }}"
        >

          <PhCloudArrowUp @size="32" class="mb-2 text-ocean-600" />
        </label>
      </FileUploader>
    {{else}}
      <FileUploader @didUploadFile={{@didUploadFile}} as |uploader|>
        <input
          id={{uploader.uniqueId}}
          type="file"
          multiple="true"
          {{uploader.queue.selectFile}}
          class="hidden"
          disabled={{or @disabled uploader.queue.files.length @isProcessing}}
        />
        <label
          for={{uploader.uniqueId}}
          class="cursor-pointer text-center font-semibold uppercase flex items-center justify-center relative overflow-hidden px-3 py-2
            {{unless @iconOnlyUpload 'border max-w-48 my-6 bg-white'}}
            {{if
              @disabled
              'border-neutral-300 text-neutral-300'
              'border-ocean-600 hover:border-ocean-800 text-ocean-600 hover:text-ocean-800'
            }}"
        >
          {{t "choose_file"}}
          {{#if (or uploader.queue.files.length @isProcessing)}}
            <div
              class="tio-row-center absolute inset-0 h-full w-full cursor-default tio-bg-surface text-ocean-600 fill-white"
              aria-hidden="true"
            >
            </div>
          {{/if}}
        </label>
        <ul class="text-xs list-disc pl-2">
          <li>
            {{t "tuition_assistance.program_details.courses.you_can_upload_multiple_attachments"}}
          </li>
        </ul>
      </FileUploader>
    {{/if}}
  </template>;

export default TuitionAssistanceFormsUploadAttachmentsUploaderComponent;
